import { DropdownAction, DropdownActionMenuItem } from 'platform/components';
import { RowActionItem } from '../../../../../../../../utils/partitionRowActions';
type ActionButtonSize = 'small' | 'default';
export type RowActionsOverflowProps = {
  overflowActions: RowActionItem[];
  onActionClick: (actionKey: string, nativeEvent: MouseEvent) => void;
  rowId: string;
  buttonSize: ActionButtonSize;
  isDisabled: boolean;
  lockedActionKeys: Set<string>;
};

/**
 * Overflow dropdown trigger for row actions without icons.
 * Renders a three-dot IconButton (more_vert) that opens a dropdown menu
 * with text-only action items.
 *
 * Returns null when overflowActions is empty — no trigger rendered.
 */
export function RowActionsOverflow(props: RowActionsOverflowProps) {
  if (props.overflowActions.length === 0) {
    return null;
  }

  // Plain derivation — React Compiler auto-memoizes. Parent memo() already prevents
  // unnecessary re-renders; no manual useMemo needed here.
  const menuItems: DropdownActionMenuItem[] = props.overflowActions.map(action => ({
    label: action.definition.title,
    isDisabled: props.isDisabled || props.lockedActionKeys.has(action.actionKey),
    onClick: event => props.onActionClick(action.actionKey, event.nativeEvent as MouseEvent),
    'data-testid': `menuItem-rowAction.${action.actionKey}`
  }));
  return <DropdownAction type="dropdown-iconButton" size={props.buttonSize} menuItems={menuItems} isDisabled={props.isDisabled} data-testid={`button-rowAction.overflow-${props.rowId}`} />;
}